export default __webpack_public_path__ + "static/media/BG-Yellow-0006.0f9199fd.png";